import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'serviceos-ng-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss']
})
export class PageContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
